/**
 * Ryan O'Dowd
 * 2024-12-04
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import {
  Platform,
} from 'react-native';

const getStyles = ({windowWidthRaw, windowHeight}) => {
  const maxHeight = windowHeight - (Platform.OS === 'web' ? (56 + 8) : 0); // @TODO: don't hardcode header height

  return {
    container: {
      position: 'absolute',
      top: 0,
      left: 0,
      flex: 1,
      width: windowWidthRaw,
      height: windowHeight,
      maxHeight,
      alignItems: 'center',
      justifyContent: 'center',
    },
    backgroundImageWrapper: {
      position: 'absolute',
      top: 0,
      left: 0,
      flex: 1,
      width: '100%',
    },
    snow: {
      width: windowWidthRaw,
      height: windowHeight,
      maxHeight,
      opacity: 0.4,
    },
  };
};

export default getStyles;
